Apt.fn.make('account.saves', {
	/**
	 * Initialize module
	 */
	init() {
		const priv = this.$private;

		if (priv.index) {
			Apt.panel.hide();

			return;
		}

		LS.api.get('me/collections', {
			auth: true,
			data: {
				limit: null
			},
			success: data => {
				const id = LS.filters.get('collection');

				priv.collections = LS.util.key(data.results);

				priv.collection = id ?
					priv.collections[id] : '';

				priv.setup();
			}
		});

		Apt.properties.prefetch();
	},

	/**
	 * Evaluate preload logic
	 */
	preload() {
		if (! this.$private.index) {
			return;
		}

		const pending = $.history.pending();

		if (! pending || ! pending.action || ! pending.run) {
			return;
		}

		pending.action = false;
	},

	/**
	 * Unload module
	 */
	unload() {
		if (
			Apt.panel.opened() ||
			$.history.get(true).segments[1] === 'saves'
		) {
			return;
		}

		LS.util.reset('saves', this.$private, [
			'index',
			'share'
		]);

		const prop = Apt.properties;

		prop.$private.section = 'properties';

		prop.unload(true);
	}
}, {
	/**
	 * Setup page
	 */
	setup() {
		const scope = this;
		const prop = Apt.properties.$private;

		scope.setHeading();

		prop.section = 'account.saves';

		prop.$private.customMap = options => {
			scope.initMap(options);
		};

		scope.make();

		LS.util.load('collect');
	},

	/**
	 * Load listings
	 */
	make() {
		const scope = this;
		const prop = Apt.properties.$private;
		const $results = $$('results');
		const app = $results.data('id');
		const sorting = Apt.properties.getSorting();

		let events;

		delete sorting['-promoted'];

		scope.index = Apt.fn.index().init({
			app: app,
			auth: true,
			paginate: true,
			path: 'account/saves',
			resource: 'me/saves',
			scrollTop: false,
			sorting: sorting,
			target: $results,
			transform: Apt.properties.transform,
			view: 'properties.results',
			params: {
				limit: 60
			},
			model: {
				empty: 'Save properties by clicking the heart on listings.',
				label: 'property'
			},
			updated: (data, init) => {
				prop.updateTracking.call(scope, data.results);

				if (! init && events) {
					events.update();
				}
			},
			unload: () => {
				if (events) {
					events.unload();
				}
			},
			destroy: () => {
				if (events) {
					events.$destroy();
				}
			}
		}, () => {
			prop.initMobile(() => {
				scope.initMap();
			});

			scope.initIndex();

			Apt['properties.panel'].init({
				map: () => prop.map
			});

			events = Apt.fn['properties.events']()
				.init({
					app: app,
					delegate: '$results',
					map: () => prop.map,
					createMap: options => {
						if (! prop.map) {
							prop.loadMap(options);
						}
					}
				});

			scope.initShare();
		});
	},

	/**
	 * Initialize map
	 *
	 * @param {Object} [options]
	 */
	initMap(options) {
		const scope = this;

		LS.util.load('maps', () => {
			scope.getPoints(data => {
				Apt.properties.$private.map = Apt.fn.maps().init('$propertiesMap', Object.assign({
					auth: true,
					countPath: 'me/saves/count',
					hideZoomMessage: true,
					points: data.results,
					reset: true,
					onClick: (id, map, feature) => {
						Apt.properties.showTooltip(id, map, feature);
					}
				}, options));
			});
		});
	},

	/**
	 * Sync collection views
	 */
	sync() {
		const scope = this;
		const collections = scope.collections;

		$.app.collections.$set({
			id: scope.collection.id,
			results: collections
		});

		$.set('user.account.collections', Object.values(collections));
	},

	/**
	 * Initialize index
	 */
	initIndex() {
		const scope = this;
		const $target = $$('filters');

		scope.active = false;

		$.app.make('collections', {
			view: 'account-saves.collections',
			target: $target
		});

		scope.sync();

		$$('collectionHeading').on('mousedown', () => {
			scope.active = ! scope.active;

			$.app.collections.$set('active', scope.active);
		}, {
			namespace: 'saves'
		});

		$.events.on('$collectionCheck', 'change', (e, el) => {
			scope.setCollection(el.checked ?
				Number(el.value) : '');
		}, {
			delegate: $target,
			namespace: 'saves'
		});

		$$('collectionAdd').on('click', () => {
			LS.modal.open({
				model: {
					title: 'Create collection',
					content: $.view.render('collect.manage', {
						modify: true
					})
				},
				success: () => {
					LS.api.bind('$collectionForm', 'me/collections', {
						namespace: 'collectionAdd',
						success: data => {
							scope.collections[data.id] = data.model;

							scope.active = false;

							scope.sync();

							LS.modal.close();
						}
					});
				},
				onHide: () => {
					$.events.reset('collectionAdd');
				}
			});
		}, {
			namespace: 'saves'
		});

		$$('collectionReset').on('click', () => {
			if (scope.collection.id) {
				scope.setCollection('');
			}
		}, {
			namespace: 'saves'
		});

		$$('collectionManage').on('click', () => {
			const id = scope.collection.id;

			LS.modal.open({
				model: {
					title: 'Modify collection',
					content: $.view.render('collect.manage', {
						id: id,
						name: $.app.collections.$get([
							'name', {
								'results.id': id
							}
						])
					}),
					footer: $.view.render('collect.manage-footer', {
						id: id
					})
				},
				success: () => {
					LS.api.bind('$collectionForm', 'me/collections/' + id, {
						method: 'patch',
						namespace: 'collectionManage',
						success: (data, xhr, req) => {
							const name = req.data.name;

							scope.collections[id].name = name;

							scope.sync();

							$$('savesHeading').text(name);

							LS.modal.close();
						}
					});

					$$('collectionDelete').on('click', () => {
						LS.modal.confirm('Are you sure you want to permanently delete this collection?', () => {
							LS.api.delete('me/collections/' + id, {
								auth: true,
								success: () => {
									delete scope.collections[id];

									scope.collection = '';

									scope.sync();

									scope.index.filter({
										collection: ''
									});

									$$('savesHeading').text('Saved listings');

									LS.modal.close();
								}
							});
						});
					}, {
						namespace: 'collectionManage'
					});
				},
				onHide: () => {
					$.events.reset('collectionManage');
				}
			});
		}, {
			namespace: 'saves'
		});
	},

	/**
	 * Initialize sharing
	 */
	initShare() {
		const scope = this;

		$$('collectionShare').on('click', () => {
			const options = {
				id: scope.collection.id,
				url: $.get('appUrl') + '/collections/' + scope.collection.token
			};

			if (scope.share) {
				scope.share.show(options);

				return;
			}

			LS.util.load('share', () => {
				scope.share = Apt.fn.share()
					.init({
						target: 'collection',
						label: 'collection'
					});

				scope.share.show(options);
			});
		}, {
			namespace: 'saves'
		});
	},

	/**
	 * Set collection
	 *
	 * @param {String} [id]
	 */
	setCollection(id) {
		const scope = this;
		const prop = Apt.properties.$private;

		scope.active = false;
		scope.collection = id ?
			scope.collections[id] : '';

		$.app.collections.$merge({
			active: scope.active,
			id: id
		});

		scope.index.filter({
			collection: id
		});

		if (prop.map) {
			scope.getPoints(data => {
				prop.map.setMarkers(data.results);
			});
		}

		scope.setHeading();
	},

	/**
	 * Set heading
	 */
	setHeading() {
		$$('savesHeading').text(this.collection ?
			this.collection.name : 'Saved listings'
		);
	},

	/**
	 * Get points
	 *
	 * @param {Function} fn
	 */
	getPoints(fn) {
		LS.api.get('me/saves/points', {
			auth: true,
			data: LS.util.sanitize({
				collection: this.collection.id
			}),
			success: data => {
				fn(data);
			}
		});
	}
});